import { useEffect, useRef } from "react";
import { AppIcon } from "./AppIcon";
import { usePins } from "../app/context/PinsContext";
import type { PinEntityType } from "../lib/authApi";
import "../styles/sidebar-context-menu.css";

type SharedTopicPin = {
  isPinned: boolean;
  onToggle: () => void;
};

type Props =
  | {
      x: number;
      y: number;
      onClose: () => void;
      mode: "personal";
      entityType: PinEntityType;
      entityId: string;
    }
  | {
      x: number;
      y: number;
      onClose: () => void;
      mode: "shared-topic";
      sharedTopic: SharedTopicPin;
    };

export function SidebarContextMenu(props: Props) {
  const { x, y, onClose } = props;
  const personal = props.mode === "personal" ? props : null;
  const shared = props.mode === "shared-topic" ? props.sharedTopic : null;

  const { isPinned, togglePin } = usePins();
  const pinned =
    personal != null ? isPinned(personal.entityType, personal.entityId) : Boolean(shared?.isPinned);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  useEffect(() => {
    const el = menuRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    if (rect.right > vw) el.style.left = `${Math.max(4, vw - rect.width - 4)}px`;
    if (rect.bottom > vh) el.style.top = `${Math.max(4, vh - rect.height - 4)}px`;
  }, []);

  const handleClick = () => {
    if (personal) {
      togglePin(personal.entityType, personal.entityId);
    } else if (shared) {
      shared.onToggle();
    }
    onClose();
  };

  return (
    <>
      <button
        type="button"
        className="sidebar-ctx-menu__backdrop"
        aria-hidden
        tabIndex={-1}
        onClick={onClose}
      />
      <div
        ref={menuRef}
        className="sidebar-ctx-menu"
        role="menu"
        style={{ left: x, top: y }}
      >
        <button
          type="button"
          role="menuitem"
          className="sidebar-ctx-menu__item"
          onClick={handleClick}
        >
          <AppIcon name={pinned ? "pin-off" : "pin"} size={14} className="sidebar-ctx-menu__icon" />
          {pinned ? "Открепить" : "Закрепить"}
        </button>
      </div>
    </>
  );
}
